import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { ASC } from "const"
import { sort } from "client/store/utils"
import {
    StoreType,
    DeleteTagSpaces,
    CreateManyTags,
    LoadAllTags,
    setTagList,
} from "client/store"
import {
    CrossIcon,
    LinkButton,
    SelectDropdownSearch,
    Empty,
    SpinnerIcon,
} from "client/components"
import {
    TagEditorWrapper,
    TagList,
    Tag,
    CloseButton,
    TagDropdownList,
    TagDropdownItem,
    CreateFromSearch,
} from "./styled"


const delimeter = ","

export interface TagEditorProps {
    selectedIds: readonly number[]
    tableView?: boolean
    readOnly?: boolean
    onChange?: (value: number[]) => void
}

export const TagEditor = ({
    selectedIds,
    tableView = false,
    readOnly = false,
    onChange = null,
}: TagEditorProps) => {
    const tagList = useSelector((state: StoreType) => state.tag.tagList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [tagIds, setTagIds] = useState<number[]>([])
    const [search, setSearch] = useState<string>("")
    const [showList, setShowList] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const dispatch = useDispatch()


    const collapseTagList = () => {
        setShowList(!showList)
    }

    useEffect(() => {
        const searchParced = search.split(delimeter)
        const searchString = searchParced.length
            ? DeleteTagSpaces(searchParced[searchParced.length - 1].toUpperCase())
            : ""

        const tagsFiltered = Object.values(tagList).filter((tag) => {
            let showRow = true
            if (selectedIds.includes(tag.id)) showRow = false
            else if (searchString.length) {
                const tagSearchString = DeleteTagSpaces(tag.name.toUpperCase())
                showRow = tagSearchString.indexOf(searchString) >= 0
            }
            return showRow
        })
        tagsFiltered.sort((a, b) => sort(a, b, "name", ASC))

        const ids: number[] = []
        tagsFiltered.forEach((tag) => ids.push(tag.id))
        setTagIds(ids)
    }, [selectedIds, search])

    const deleteTag = (tagId: number) => {
        const newSelectedIds = selectedIds.filter((id) => id !== tagId)
        onChange(newSelectedIds)
    }

    const addTag = (tagId: number) => {
        const newSelectedIds = selectedIds.slice()
        newSelectedIds.push(tagId)
        onChange(newSelectedIds)
    }

    const createFromSearch = () => {
        const tagArray = search.split(delimeter)
        setIsSaving(true)
        CreateManyTags(tagArray, lang).then((newTagIds) => {
            LoadAllTags().then((res) => {
                dispatch(setTagList(res.tagList))
                setIsSaving(false)
                setSearch("")

                const newSelectedIds = selectedIds.concat(newTagIds)
                onChange(newSelectedIds)
            })
        })
    }

    return (
        <TagEditorWrapper tableView={tableView}>
            <TagList tableView={tableView}>
                {
                    !selectedIds.length
                    && <Empty />
                }
                {
                    selectedIds.map((tagId) => (
                        <Tag key={tagId}>
                            {tagList[tagId] && tagList[tagId].name}
                            {
                                !readOnly && (
                                    <CloseButton onClick={() => deleteTag(tagId)}>
                                        <CrossIcon />
                                    </CloseButton>
                                )
                            }
                        </Tag>
                    ))
                }
            </TagList>

            {
                !readOnly && (
                    <LinkButton onClick={collapseTagList}>
                        {
                            !showList
                                ? `+ ${lang.add}`
                                : `- ${lang.close}`
                        }
                    </LinkButton>
                )
            }
            {
                !readOnly && (
                    <TagDropdownList show={showList}>
                        <SelectDropdownSearch
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onClearSearch={() => setSearch("")}
                        />
                        {
                            search.length > 0 && (
                                <CreateFromSearch onClick={createFromSearch}>
                                    {lang.createFromSearch}
                                    {isSaving && <SpinnerIcon />}
                                </CreateFromSearch>
                            )
                        }
                        {
                            tagIds.map((tagId) => (
                                <TagDropdownItem
                                    key={tagId}
                                    onClick={() => addTag(tagId)}
                                >
                                    {tagList[tagId].name}
                                </TagDropdownItem>
                            ))
                        }
                    </TagDropdownList>
                )
            }
        </TagEditorWrapper>
    )
}
